<template>
  <header class="header section-header">
    <div v-if="companySelect" class="header__company_select">
      <CompanySelect v-show="companyEdit" v-model="selectedCompanyUuid" @input="companyEdit = false" />
      <button v-show="!companyEdit" class="company-edit-toggle" @click="companyEdit = true">
        {{ companyUser.company_name }}
      </button>
    </div>

    <BreadCrumbSeparator v-if="companySelect" />

    <div class="header__title">
      <slot name="breadcrumbs">
        <BreadCrumbs :items="[{ text: title }]" />
      </slot>
    </div>

    <div class="header__controls">
      <div class="header__controls-project-select" v-if="projectSelect">
        <ProjectsSelect v-model="selectedProjectUuids" :companyUuid="companyUuid || selectedCompanyUuid" />
      </div>
    </div>
    <div class="header__meta">
      <slot name="meta" />
    </div>
  </header>
</template>

<script>
import BreadCrumbSeparator from '@/components/BreadCrumbs/BreadCrumbSeparator.vue'
import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import CompanySelect from '@/components/CompanySelect'
import ProjectsSelect from '@/components/ProjectsSelect'

export default {
  components: {
    BreadCrumbs,
    BreadCrumbSeparator,
    CompanySelect,
    ProjectsSelect,
  },
  props: {
    title: { type: String, required: false },
    companySelect: { type: Boolean, default: true },
    projectSelect: { type: Boolean, default: false },
    // if the company select is disabled but the project select is enabled companyUuid needs to be supplied
    companyUuid: { type: String, required: false },
  },
  inject: ['companyUser'],
  data: () => ({
    companyEdit: false,
    selectedCompanyUuid: null,
    selectedProjectUuids: [],
  }),
  watch: {
    selectedProjectUuids() {
      this.$emit('selectProjectUuids', this.selectedProjectUuids)
    },
  },
}
</script>

<style lang="scss" scoped>
.company-edit-toggle {
  padding: 0;
  cursor: pointer;
  border: 0;
  background-color: transparent;
  color: var(--primary-font-color);
  font-size: 22px;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &:hover {
    color: color-mix(in srgb, var(--primary-font-color) 80%, white);
  }
}

.header {
  justify-content: space-between;
  align-items: center;

  .header__title {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    flex: 0.1 1 auto;
  }

  .header__controls {
    display: flex;
    padding: 10px;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    column-gap: 10px;

    .header__controls-project-select {
      flex: 1 0;
      display: flex;
      align-items: center;
      column-gap: 10px;

      .v-select {
        flex: 1;
      }
    }
  }

  .header__meta {
    flex: 0.1 0.5 auto;
    text-align: right;
    align-self: center;

    .button {
      margin-left: 5px;
    }
  }
}
</style>
